export const SHORT_DATE_FORMAT = 'l'
export const TIME_FORMAT = 'h:mma'



// WEBPACK FOOTER //
// ./src/constants/momentFormats.js